import { render, staticRenderFns } from "./RelServicosPorTecnico.vue?vue&type=template&id=7f37f120"
import script from "./RelServicosPorTecnico.vue?vue&type=script&lang=js"
export * from "./RelServicosPorTecnico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports